import React from 'react'
import { dialogTypes } from 'decorators'
import {
  AlertDialog,
  ConfirmDialog,
  ChangeThemeDialog,
  NotImplementedDialog,
  OrderedWineDialog,
  WineDialog,
  ProducerDialog,
  CurrencyDialog,
  SupplierDialog,
  RegionDialog,
  CountryDialog,
  DistrictDialog,
  SubdistrictDialog,
  GrapeDialog,
  WineStyleDialog,
  EvaluatorDialog,
  WineTypeDialog,
  ProduceStyleDialog,
  VineyardStyleDialog,
  StoragePlacesDialog,
  AddFilterDialog,
  BottleDialog,
  BottleSimpleDialog,
  ImageDialog,
  ClassificationByOriginDialog,
  ClassificationByParamsDialog,
  FlavourCharacteristicsDialog,
  WinesInStockDialog
} from 'dialogs'

const DialogsSwitch = ({ dialogs, localize, hideDialog }) => {
  if (dialogs.length === 0) { return null }

  const x = dialogs[0]
  const { dialogType, context } = x.options
  const commonProps = {
    key: x.dialogKey,
    isOpen: true,
    context,
    localize: localize,
    hideDialog,
    nestedDialogs: dialogs.slice(1)
  }

  switch (dialogType) {
    case dialogTypes.alert: return <AlertDialog {...commonProps} />
    case dialogTypes.confirm: return <ConfirmDialog {...commonProps} />
    case dialogTypes.changeTheme: return <ChangeThemeDialog {...commonProps} />
    case dialogTypes.notImplemented: return <NotImplementedDialog {...commonProps} />
    case dialogTypes.orderedWine: return <OrderedWineDialog {...commonProps} />
    case dialogTypes.wineDetail: return <WineDialog {...commonProps} />
    case dialogTypes.producerDetail: return <ProducerDialog {...commonProps} />
    case dialogTypes.currencyDetail: return <CurrencyDialog {...commonProps} />
    case dialogTypes.supplierDetail: return <SupplierDialog {...commonProps} />
    case dialogTypes.regionDetail: return <RegionDialog {...commonProps} />
    case dialogTypes.countryDetail: return <CountryDialog {...commonProps} />
    case dialogTypes.districtDetail: return <DistrictDialog {...commonProps} />
    case dialogTypes.subdistrictDetail: return <SubdistrictDialog {...commonProps} />
    case dialogTypes.grapeDetail: return <GrapeDialog {...commonProps} />
    case dialogTypes.wineStyleDetail: return <WineStyleDialog {...commonProps} />
    case dialogTypes.evaluatorDetail: return <EvaluatorDialog {...commonProps} />
    case dialogTypes.wineTypeDetail: return <WineTypeDialog {...commonProps} />
    case dialogTypes.classificationByOriginDetail: return <ClassificationByOriginDialog {...commonProps} />
    case dialogTypes.classificationByParamsDetail: return <ClassificationByParamsDialog {...commonProps} />
    case dialogTypes.flavourCharacteristicsDetail: return <FlavourCharacteristicsDialog {...commonProps} />
    case dialogTypes.produceStyleDetail: return <ProduceStyleDialog {...commonProps} />
    case dialogTypes.vineyardStyleDetail: return <VineyardStyleDialog {...commonProps} />
    case dialogTypes.storagePlaceDetail: return <StoragePlacesDialog {...commonProps} />
    case dialogTypes.addFilter: return <AddFilterDialog {...commonProps} />
    case dialogTypes.bottleDetail: return <BottleDialog {...commonProps} />
    case dialogTypes.bottleSimpleDetail: return <BottleSimpleDialog {...commonProps} />
    case dialogTypes.imageDetail: return <ImageDialog {...commonProps} />
    case dialogTypes.winesInStockDetail: return <WinesInStockDialog {...commonProps} />
    
    default: return null
  }
}

export default DialogsSwitch
